import { loadView } from '@/router'

export default [
  {
    path: 'surcharges',
    name: 'manage-surcharges',
    component: loadView('Application/Manage/Surcharges'),
    showInAlfred: true,
    alfredTitle: 'Manage - Surcharges'
  }
]
